<template lang="pug">
    .reaction
        input.input(
            type="input"
            v-bind:name="getUniqueInformationName"
            v-bind:placeholder="getContent"
            :disabled="answered == true"
         v-model="value"
       )
</template>
<script>
    import store from '@/store';
    import { mapGetters } from 'vuex'
    export default {
       name: 'Input',
       props: {
         inputType: {
          type: String,
          required: true
         },
         content: {
          type: Object,
          required: true
         },
         information: {
          type: Object,
          required: true
         },
         answered: {
          type: Boolean
         },
         reaction: {
          type: Object,
          required: true
         },
         section: {
                type: Object,
                required: true
            }
       },
       computed: {
         getUniqueInformationName() {
          return 'single-choice-ID' + this.information.id
         },
         getContent() {
          return this.content.title
         },
         value: {
                get() {
                  if( _.has(this.evaluation, `informations.${this.information.id}.reactions.${this.reaction.id}.value`)) {
                    return this.evaluation.informations[this.information.id].reactions[this.reaction.id].value
                  }
                  return this.content.text
                },
                set(value) {
                    const payload = {
                        value,
                        page: parseInt(this.currentPageId),
                        information: this.information,
                        reaction: this.reaction,
                        section: this.section
                    }
                    store.commit(`currentPage/evaluationReactionInputFieldValue`, payload)
                }
            },
            ...mapGetters({
                currentPageId: 'currentPage/id',
                evaluation: 'currentPage/evaluation'
            })
        }
    }
</script>
<style lang="sass">
</style>